<template>
  <!-- 新增服务网点 -->
  <div>
    <el-dialog
      :title="title"
      :visible.sync="mapDialogVisible"
      width="850px"
      :before-close="handleClose"
      v-if="mapDialogVisible"
      :close-on-click-modal="false"
    >
      <div class="module-content">
        <div class="module-info">
          <div class="map-contents">
            <div class="map-input">
              <input type="text" v-model="addrValue" id="map-input" />
              <div @click="searchGoogle()" v-if="isGoogle">
                <i class="el-icon-search"></i>
              </div>
              <div @click="getLocation()" v-else>
                <i class="el-icon-search"></i>
              </div>
            </div>
            <div v-if="isAdd == 3" class="Mantle"></div>
            <div id="platform-map"></div>
          </div>
        </div>
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="auto"
        >
          <div class="position">
            <el-form-item class="position-c" label-width="0px" prop="address">
              <el-input
                disabled
                class="position-a"
                v-model="ruleForm.address"
                :placeholder="$t('afterSales.text9')"
              ></el-input>
            </el-form-item>
            <el-form-item label-width="0px" prop="location">
              <el-input
                disabled
                class="position-b"
                v-model="ruleForm.location"
                :placeholder="$t('afterSales.text10')"
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item :label="$t('afterSales.text11')" prop="logoImagePath">
            <DiluUploadImage
              :disabled="isAdd == 3"
              :limit="1"
              accept=".png,.jpg,.jpeg"
              :fileList="fileList"
              @remove="removeimg"
              @success="success"
              limitWidth="200"
              limitHeight="200"
              :uploaDisabled="isAdd == 3"
            />
          </el-form-item>
          <el-form-item
            :label="$t('afterSales.text1')"
            prop="serviceStationName"
          >
            <el-input
              clearable
              :disabled="isAdd == 3"
              class="name"
              v-model="ruleForm.serviceStationName"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('afterSales.text3')" prop="serviceContent">
            <el-checkbox-group v-model="ruleForm.serviceContent">
              <el-checkbox :disabled="isAdd == 3" :label="1" name="type">{{
                $t("afterSales.text6")
              }}</el-checkbox>
              <el-checkbox :disabled="isAdd == 3" :label="2" name="type">{{
                $t("afterSales.text7")
              }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item :label="$t('afterSales.text2')" prop="principal">
            <el-input
              clearable
              :disabled="isAdd == 3"
              class="name"
              v-model="ruleForm.principal"
            ></el-input>
          </el-form-item>
          <div class="number">
            <el-form-item :label="$t('afterSales.text12')" prop="areaCode">
              <el-select
                clearable
                :disabled="isAdd == 3"
                class="number-a"
                v-model="ruleForm.areaCode"
                :placeholder="$t('afterSales.text13')"
              >
                <el-option
                  v-for="(item, index) in arelist"
                  :key="index"
                  :label="item.city + item.code"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label-width="10px" prop="phone">
              <el-input
                onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                clearable
                :disabled="isAdd == 3 || this.ruleForm.areaCode == ''"
                class="number-b"
                v-model="ruleForm.phone"
              ></el-input>
            </el-form-item>
            <span class="tip">{{ $t("afterSales.text14") }}</span>
          </div>
          <el-form-item :label="$t('pages.system.text95')" prop="mail">
            <el-input
              clearable
              :disabled="isAdd == 3"
              class="name"
              v-model="ruleForm.mail"
            ></el-input>
          </el-form-item>
          <div class="time">
            <div class="time-a">{{ $t("afterSales.text5") }}</div>
            <el-form-item prop="serveStartTime" label-width="0px">
              <el-time-picker
                value-format="HH:mm:ss"
                :disabled="isAdd == 3"
                v-model="ruleForm.serveStartTime"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
                :placeholder="$t('afterSales.text15')"
              >
              </el-time-picker>
            </el-form-item>
            <span class="time-c">--</span>
            <el-form-item prop="serveStopTime" label-width="0">
              <el-time-picker
                value-format="HH:mm:ss"
                :disabled="isAdd == 3"
                v-model="ruleForm.serveStopTime"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
                :placeholder="$t('afterSales.text16')"
              >
              </el-time-picker>
            </el-form-item>
          </div>
          <el-form-item :label="$t('afterSales.text4')" prop="status">
            <el-radio-group v-model="ruleForm.status">
              <el-radio :disabled="isAdd == 3" :label="0">{{
                $t("pages.operate.text4")
              }}</el-radio>
              <el-radio :disabled="isAdd == 3" :label="1">{{
                $t("pages.operate.text5")
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('pages.operate.text36')">
            <el-input
              :disabled="isAdd == 3"
              class="remarks"
              type="textarea"
              :placeholder="$t('pages.operate.text36')"
              v-model="ruleForm.remark"
              maxlength="200"
              show-word-limit
              rows="4"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t("button.cancel") }}</el-button>
        <el-button v-if="this.isAdd != 3" type="primary" @click="submit()">{{
          $t("button.determine")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import { mapState } from "vuex";
import DiluUploadImage from "../../../../components/pubilc/dilu-uploadimages.vue";
import remoteLoad from "@/assets/js/remoteLoad.js";
import { resetTime } from "../../../../utils/util/validate";
import { validatEmailAddress } from "../../../../utils/util/test";
import areaCodeList from "../../../../utils/util/area-code.json";
export default {
  data() {
    return {
      arelist: [],
      openMap: false,
      title: this.$t("afterSales.text17"),
      isGoogle: false,
      addrValue: "", //地图搜索
      marker: null,
      map: null,
      center: [116.397428, 39.90923],
      fileList: [],
      ruleForm: {
        location: "",
        id: "", //主键id
        regionList: [], //自定义字段
        serviceContent: [],
        latitude: "", //纬度
        longitude: "", // 经度
        address: "", // 详细地址
        serviceStationName: "", // 网点名称
        logoImageName: "", //Logo图片的名称
        logoImagePath: "", //logo图片地址
        areaCode: "", //  区号
        mail: "", //邮箱
        phone: null, //电话
        principal: "", //负责人
        serveStartTime: "", // 开始营业时间
        serveStopTime: "", // 结束营业时间
        status: null, //状态 0启用 1禁用
        remark: "", //备注
      },
      statu: null,
      province: "", //一级行政区
      city: "", //二级行政区
      addr: "", //地址
      address_components: [],
      rules: {
        address: [
          {
            required: true,
            message: this.$t("afterSales.text18"),
            trigger: "change",
          },
        ],
        location: [
          {
            required: true,
            message: this.$t("afterSales.text19"),
            trigger: "change",
          },
        ],
        serviceStationName: [
          {
            required: true,
            message: this.$t("afterSales.text20"),
            trigger: "blur",
          },
          { max: 128, message: this.$t("afterSales.text33"), trigger: "blur" },
        ],
        logoImagePath: [
          {
            required: true,
            message: this.$t("afterSales.text21"),
            trigger: "blur",
          },
        ],
        principal: [
          {
            required: true,
            message: this.$t("afterSales.text22"),
            trigger: "blur",
          },
          { max: 128, message: this.$t("afterSales.text33"), trigger: "blur" },
        ],
        status: [
          {
            required: true,
            message: this.$t("afterSales.text23"),
            trigger: "change",
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t("afterSales.text24"),
            trigger: "blur",
          },
        ],
        areaCode: [
          {
            required: true,
            message: this.$t("afterSales.text25"),
            trigger: "change",
          },
        ],
        serviceContent: [
          {
            required: true,
            message: this.$t("afterSales.text26"),
            trigger: "change",
          },
        ],
        serveStartTime: [
          {
            required: true,
            message: this.$t("afterSales.text27"),
            trigger: "blur",
          },
        ],
        serveStopTime: [
          {
            required: true,
            message: this.$t("afterSales.text28"),
            trigger: "blur",
          },
        ],
        mail: [{ validator: validatEmailAddress, trigger: "blur" }],
      },
    };
  },
  computed: {
    ...mapState(["platformData", "regionList", "currentRegion"]),
  },
  components: {
    DiluUploadImage,
  },
  mounted() {
    this.arelist = areaCodeList.list;
  },
  watch: {
    mapDialogVisible(newValue) {
      this.openMap = true;
      if (newValue) {
        if (this.isAdd == 1) {
          this.title = this.$t("afterSales.text17"); //新增服务网点
        }
        if (this.isAdd == 2) {
          this.title = this.$t("afterSales.text29"); //编辑服务网点
        }
        if (this.isAdd == 3) {
          this.openMap = false;
          this.title = this.$t("afterSales.text30"); //查看服务网点
        }
        if (this.isAdd != 1) {
          this.ruleForm = {
            location:
              this.currentRole.longitude + "," + this.currentRole.latitude,
            id: this.currentRole.id,
            serviceContent: this.currentRole.serviceContent,
            address: this.currentRole.address, // 详细地址
            serviceStationName: this.currentRole.serviceStationName, // 网点名称
            logoImageName: this.currentRole.logoImageName,
            logoImagePath: this.currentRole.logoImagePath,
            areaCode: this.currentRole.areaCode, //  区号
            mail: this.currentRole.mail, //邮箱
            phone: this.currentRole.phone, //电话
            principal: this.currentRole.principal, //负责人
            serveStartTime: this.currentRole.serveStartTime, // 开始营业时间
            serveStopTime: this.currentRole.serveStopTime, // 结束营业时间
            status: this.currentRole.status, //状态 0启用 1禁用
            remark: this.currentRole.remark, //备注
          };
          this.fileList.push({
            name: this.currentRole.logoImageName,
            url: this.currentRole.logoImagePath,
          });
        }
        if (this.ruleForm.location) {
          // this.initMap();
          let regionList = this.regionList;

          if (regionList[this.currentRegion].id != "cn") {
            if (window.google) {
              this.initMap();
              // 未载入谷歌地图API，则先载入API再初始化
            } else {
              // 载入谷歌地图和UI组件
              Promise.all([
                remoteLoad(
                  "https://maps.googleapis.com/maps/api/js?key=AIzaSyByfqxMers4lp-sXvkU4P8dX4i6yQ3RZ84&libraries=visualization,places,geometry&language=en-us&region=EG"
                ),
              ]).then(() => {
                this.initMap();
              });
            }
          } else {
            if (window.AMap && window.AMapUI) {
              this.initMap();
              // 未载入高德地图API，则先载入API再初始化
            } else {
              // 载入高德地图和UI组件
              Promise.all([
                remoteLoad(
                  "https://webapi.amap.com/maps?v=1.4.15&key=77faf27c291ef4d7a20bfb8d5f74b0b4&plugin=AMap.Riding"
                ),
              ]).then(() => {
                this.initMap();
              });
            }
          }
          let addrArr = this.ruleForm.location.split(",");
          let arr = this.regionList;
          if (arr[this.currentRegion].id != "cn") {
            let addr = { lat: Number(addrArr[1]), lng: Number(addrArr[0]) };
            setTimeout(() => {
              this.setGoogleMarker(addr);
            }, 500);
          } else {
            setTimeout(() => {
              this.setMarker({
                lat: Number(addrArr[1]),
                lng: Number(addrArr[0]),
              });
            }, 500);
          }
        } else {
          // this.initMap();
          let regionList = this.regionList;

          if (regionList[this.currentRegion].id != "cn") {
            if (window.google) {
              this.initMap();
              // 未载入谷歌地图API，则先载入API再初始化
            } else {
              // 载入谷歌地图和UI组件
              Promise.all([
                remoteLoad(
                  "https://maps.googleapis.com/maps/api/js?key=AIzaSyByfqxMers4lp-sXvkU4P8dX4i6yQ3RZ84&libraries=visualization,places,geometry&language=en-us&region=EG"
                ),
              ]).then(() => {
                this.initMap();
                this.map.setCenter("{" + this.ruleForm.location + "}");
              });
            }
          } else {
            if (window.AMap && window.AMapUI) {
              this.initMap();
              // 未载入高德地图API，则先载入API再初始化
            } else {
              // 载入高德地图和UI组件
              Promise.all([
                remoteLoad(
                  "https://webapi.amap.com/maps?v=1.4.15&key=77faf27c291ef4d7a20bfb8d5f74b0b4&plugin=AMap.Riding"
                ),
              ]).then(() => {
                this.initMap();
              });
            }
          }
        }
      }
    },
  },
  props: ["mapDialogVisible", "currentRole", "isAdd"],
  methods: {
    //取消
    handleClose() {
      this.fileList = [];
      this.ruleForm = {
        location: "",
        id: "",
        serviceContent: [],
        latitude: "", //纬度
        longitude: "", // 经度
        address: "", // 详细地址
        serviceStationName: "", // 网点名称
        logoImageName: "",
        logoImagePath: "",
        areaCode: "", //  区号
        mail: "", //邮箱
        phone: null, //电话
        principal: "", //负责人
        serveStartTime: "", // 开始营业时间
        serveStopTime: "", // 结束营业时间
        status: null, //状态 0启用 1禁用
        remark: "", //备注
      };
      this.openMap = false;
      this.$refs["ruleForm"].resetFields();
      this.$emit("mapdialogVisibleCloe");
    },
    //初始化地图
    initMap() {
      let arr = this.regionList;
      if (arr[this.currentRegion].id != "cn") {
        setTimeout(() => {
          this.initGoogleMap();
          this.isGoogle = true;
        }, 500);
      } else {
        this.initCnMap();
        this.isGoogle = false;
      }
    },
    //初始化谷歌地图
    initGoogleMap() {
      let that = this;
      that.map = new google.maps.Map(document.getElementById("platform-map"), {
        center: { lat: -34.397, lng: 150.644 },
        mapId: "1dac188ecae44d48",
        zoom: 8,
        mapTypeControl: false,
        disableDefaultUI: true,
      });
      that.map.addListener("click", (mapsMouseEvent) => {
        that.setGoogleMarker({
          lat: mapsMouseEvent.latLng.lat(),
          lng: mapsMouseEvent.latLng.lng(),
        });
      });
    },
    //设置谷歌地图点
    setGoogleMarker(e) {
      let that = this;
      if (that.marker) {
        that.marker.setMap(null);
      }
      that.marker = new google.maps.Marker({
        position: new google.maps.LatLng(e),
        map: that.map,
      });
      console.log(new google.maps.LatLng(e));
      this.ruleForm.location = "" + e.lng + "," + e.lat;
      this.ruleForm.longitude = e.lng;
      this.ruleForm.latitude = e.lat;
      this.map.setCenter(new google.maps.LatLng(e));
      this.getGoogleAddress(e);
    },
    //谷歌地图搜索服务
    searchGoogle() {
      let that = this;
      const request = {
        query: that.addrValue,
        fields: ["name", "geometry"],
      };

      let service = new google.maps.places.PlacesService(that.map);
      service.findPlaceFromQuery(request, (results, statu) => {
        if (statu === google.maps.places.PlacesServiceStatus.OK && results) {
          that.map.setCenter(results[0].geometry.location);
          that.setGoogleMarker({
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
          });
        }
      });
    },
    //谷歌地图地理编码
    getGoogleAddress(e) {
      let that = this;
      const geocoder = new google.maps.Geocoder();
      geocoder
        .geocode({ location: e })
        .then((response) => {
          if (response.results[0]) {
            let arr = response.results[1].address_components;
            for (let i in arr) {
              for (let j in arr[i].types) {
                if (arr[i].types[j] == "country") {
                  that.country = arr[i].long_name; // 国家
                }
                if (arr[i].types[j] == "administrative_area_level_1") {
                  that.province = arr[i].long_name; // 一级行政区
                }
                if (
                  arr[i].types[j] == "administrative_area_level_2" ||
                  arr[i].types[j] == "locality"
                ) {
                  that.city = arr[i].long_name; // 二级行政区
                }
              }
            }
            that.ruleForm.address = "" + that.province + "," + that.city;
          } else {
            window.alert("No results found");
          }
        })
        .catch((e) => window.alert("Geocoder failed due to: " + e));
    },
    //初始化高德地图
    initCnMap() {
      let that = this;
      this.map = new AMap.Map("platform-map", {
        mapStyle: "amap://styles/398469a1eaea0a930c1cb33226ee3080", //设置地图的显示样式
        zoom: 5,
        resizeEnable: true,
      });
      //为地图注册click事件获取鼠标点击出的经纬度坐标
      this.map.on("click", function (e) {
        that.setMarker({ lng: e.lnglat.getLng(), lat: e.lnglat.getLat() });
      });
    },
    //高德地图设置点
    setMarker(e) {
      let that = this;
      if (that.marker) {
        that.marker.setMap(null);
        that.marker = null;
      }
      that.marker = new AMap.Marker({
        icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
        position: [e.lng, e.lat],
      });
      that.marker.setMap(that.map);
      that.map.setCenter([e.lng, e.lat]);
      that.getAddress([e.lng, e.lat]);
      this.ruleForm.location = e.lng + "," + e.lat;
      this.ruleForm.longitude = e.lng;
      this.ruleForm.latitude = e.lat;
    },
    //高德搜索位置
    getLocation() {
      let that = this;
      AMap.service(["AMap.PlaceSearch"], function () {
        var placeSearch = new AMap.PlaceSearch();
        placeSearch.search(that.addrValue, function (statu, result) {
          if (statu == "complete" && result.info == "OK") {
            that.setMarker({
              lng: result.poiList.pois[0].location.lng,
              lat: result.poiList.pois[0].location.lat,
            });
            that.addrValue = "";
          } else {
            that.$message({
              message: this.$t("pages.operate.text45"),
              type: "warning",
            });
          }
        });
      });
    },
    //逆向地理编码
    getAddress(e) {
      let that = this;
      AMap.plugin("AMap.Geocoder", function () {
        var geocoder = new AMap.Geocoder();
        geocoder.getAddress(e, function (statu, result) {
          if (statu === "complete" && result.info === "OK") {
            //result为对应的地理位置详细信息
            that.ruleForm.address =
              "" +
              result.regeocode.addressComponent.province +
              "," +
              result.regeocode.addressComponent.city;
          } else {
            that.$message({
              message: that.$t("pages.operate.text46"),
              type: "warning",
            });
          }
        });
      });
    },
    //确定
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.isAdd == 1) {
            if (this.ruleForm.serveStopTime && this.ruleForm.serveStartTime) {
              this.ruleForm.serveStopTime = resetTime(
                this.ruleForm.serveStopTime
              ); // 结束时间
              this.ruleForm.serveStartTime = resetTime(
                this.ruleForm.serveStartTime
              ); // 开始时间
            }
            if (this.ruleForm.location) {
              let add = this.ruleForm.location;
              this.ruleForm.latitude = add.split(",")[1];
              this.ruleForm.longitude = add.split(",")[0];
            }
            let str = this.ruleForm;
            delete str.location;
            this.request
              .networkAdd(str)
              .then(() => {
                this.$emit("networkList");
                this.$message.success(this.$t("afterSales.text31"));
                this.handleClose();
              })
              .catch(() => {});
          } else {
            if (this.ruleForm.serveStopTime && this.ruleForm.serveStartTime) {
              this.ruleForm.serveStopTime = resetTime(
                this.ruleForm.serveStopTime
              ); // 结束时间
              this.ruleForm.serveStartTime = resetTime(
                this.ruleForm.serveStartTime
              ); // 开始时间
            }
            if (this.ruleForm.location) {
              let add = this.ruleForm.location;
              this.ruleForm.latitude = add.split(",")[1];
              this.ruleForm.longitude = add.split(",")[0];
            }
            let str = this.ruleForm;
            delete str.location;
            this.request
              .networkEdit(str)
              .then(() => {
                this.$emit("networkList");
                this.$message.success(this.$t("afterSales.text32"));
                this.handleClose();
              })
              .catch(() => {});
          }
        }
      });
    },
    //删除图片
    removeimg(e) {
      const i = this.fileList.findIndex((x) => x.name == e);
      this.fileList.splice(i, 1);
      this.ruleForm.logoImageName = null;
      this.ruleForm.logoImagePath = null;
    },
    //上传成功
    success(e) {
      this.ruleForm.logoImageName = e.name;
      this.ruleForm.logoImagePath = e.url;
      this.fileList = e.fileList;
      this.$refs["ruleForm"].clearValidate();
    },
  },
};
</script>

<style scoped>
#platform-map {
  width: 100%;
  height: 350px;
  margin-bottom: 20px;
  position: relative;
}
.module-content {
  display: flex;
  flex-direction: column;
}
#addmap {
  width: 800px;
  height: 300px;
  margin-bottom: 20px;
}
.position {
  display: flex;
  margin-bottom: 10px;
}
.position-a {
  margin-left: 20px;
  width: 370px;
}
.position-c {
  margin-right: 20px;
}
.position-b {
  width: 370px;
}
.name {
  width: 40%;
}
.number {
  display: flex;
}
.number-a {
  width: 150px;
}
.tip {
  line-height: 50px;
  margin-left: 10px;
}
.time {
  display: flex;
}
.time-a {
  margin: 10px 13px 0 20px;
}
.time-c {
  margin: 10px 10px 0 10px;
}
.el-form-item {
  margin-bottom: 20px;
}
.remarks {
  width: 40%;
}
.inputs {
  width: 100%;
  display: flex;
  margin-bottom: 16px;
}
.module-info {
  padding: 20px;
  box-sizing: border-box;
}
.info-button {
  margin: 40px 0;
  display: flex;
  justify-content: center;
}
#platform-map {
  width: 100%;
  height: 350px;
  margin-bottom: 20px;
}
.map-contents {
  position: relative;
}
.map-input {
  width: 260px;
  height: 46px;
  background-color: #fff;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 22;
  border-radius: 8px;
  box-shadow: 0 2px 6px 0 rgb(114 124 245 / 50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 10px;
  box-sizing: border-box;
}
.map-input input {
  flex: 1;
  border: none;
  outline: none;
  background-color: transparent;
}
.map-input div {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  height: 100%;
  border-left: 1px solid #dfdfdf;
  cursor: pointer;
}
.map-input div i {
  font-size: 24px;
}
.Mantle {
  width: 100%;
  height: 350px;
  background: transparent;
  opacity: 1;
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 22;
}
</style>